import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import { IAppSummary } from '../abstractions/IAppSummary';
import { LoadingStates } from '@tdp/common/constants';


const appListEntityAdapter = createEntityAdapter<IAppSummary, string>({
  selectId: (app) => app.teamsAppId
});

const initialState = {
  apps: appListEntityAdapter.getInitialState(),
  loading: LoadingStates.NOT_STARTED,
  currentPage: 1,
  appsCount: 0,
}

export const appListSlice = createSlice({
  name: "appList",
  initialState,
  reducers: {
    appCountLoaded: (state, payloadAction: PayloadAction<number>) => {
      state.appsCount = payloadAction.payload
    },
    appListLoading: (state) => {
      state.loading = LoadingStates.LOADING;
    },
    appListLoadingFailed: (state) => {
      state.loading = LoadingStates.ERROR;
    },
    appsListLoaded: (state, action: PayloadAction<IAppSummary[]>) => {
      state.currentPage = state.currentPage + 1
      state.loading = LoadingStates.SUCCESS;
      appListEntityAdapter.upsertMany(state.apps, action.payload);
    },
    appListItemDeleted: (state, action: PayloadAction<string>) => {
      appListEntityAdapter.removeOne(state.apps, action.payload);
    },
    newAppCreatedSuccess: (state, action: PayloadAction<IAppSummary>) => {
      appListEntityAdapter.addOne(state.apps, action.payload);
    },
  },
  selectors: {
    loading: (s) => s.loading,
    appsCount: (s) => s.appsCount,
    apps: (s) => s.apps,
    adapter: (s) => appListEntityAdapter,
    currentPage: (s) => s.currentPage,
  }
})
